// Blind Barrels – Cart Security Guard
// Remove old "free" variants if they show up via old links or hacks.
// Spec: _specs/025-p0-critical-fixes.md (Issue #15)
//
// DEFENSE-IN-DEPTH: This guard runs client-side only. It is NOT a security
// boundary — a user who disables JavaScript or calls the Shopify AJAX API
// directly can bypass it. Server-side enforcement via Shopify Scripts (Plus
// feature) is recommended as a future hardening step.

(function () {
  if (window.BlindBarrelsCartSecurityInit) return;
  window.BlindBarrelsCartSecurityInit = true;

  // Variant IDs that must NEVER be purchasable from the storefront.
  // Only truly legacy "free" variants should be blocked here.
  //
  // CONTEXT (March 2026):
  // 44675174564047 is the legacy free 4-glass variant. It is INTENTIONALLY
  // blocked here. Existing subscribers who purchased this variant are managed
  // server-side by Bold Subscriptions — they do NOT go through the storefront
  // cart. New customers should use variant 44688158589135 (5th Bonus Kit +
  // 4 Custom Tasting Glasses). Old subscription-box section references in
  // JSON templates are for backward compatibility and do not affect cart flow.
  const BLOCKED_VARIANTS = [
    44675174564047, // Legacy 4-glass "included" variant — blocked for new purchases
    // NOTE:
    //  - 44675174301903 (Quarterly included glass)
    //  - 44675171680463 (5th bonus kit included)
    // are ACTIVE bonus variants and must not be blocked here.
  ];

  // Config drift check: warn if central config disagrees with hardcoded blocklist.
  // See _specs/029-remaining-observations.md (Issue #34)
  (function checkConfigDrift() {
    var vc = window.bbVariantConfig;
    if (vc && vc.legacyGlass && vc.legacyGlass !== 44675174564047) {
      console.warn(
        '[securityGuard] Config drift: bbVariantConfig.legacyGlass is',
        vc.legacyGlass,
        'but BLOCKED_VARIANTS expects 44675174564047. Update cart-security-guard.js.'
      );
    }
  })();

  async function cleanCartIfNeeded(options) {
    const opts = options || {};
    const reloadOnChange = opts.reloadOnChange !== false; // default true

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;

      const cart = await res.json();
      const items = cart.items || [];
      if (!items.length) return;

      const updates = {};
      let changed = false;

      items.forEach((item) => {
        // In /cart.js, item.id is the variant ID
        const variantId = item.id;
        if (BLOCKED_VARIANTS.includes(variantId)) {
          updates[variantId] = 0; // Remove this variant from cart
          changed = true;
        }
      });

      if (!changed) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
        credentials: 'same-origin',
      });

      if (reloadOnChange) {
        window.location.href = '/cart';
      }
    } catch (e) {
      console.error('Blind Barrels cart security guard error:', e);
    }
  }

  function initSecurityGuard() {
    const path = window.location.pathname;

    // If they hit a /cart/... permalink (like /cart/44675174564047:1),
    // immediately sanitize the cart.
    if (path.startsWith('/cart')) {
      cleanCartIfNeeded({ reloadOnChange: true });
    }

    // Optionally also guard checkout attempts
    document.addEventListener(
      'click',
      function (evt) {
        const btn = evt.target.closest('button[name="checkout"], a[href="/checkout"]');
        if (!btn) return;

        evt.preventDefault();
        cleanCartIfNeeded({ reloadOnChange: true }).then(() => {
          // After sanitizing, if nothing blocked remains, send them to checkout
          window.location.href = '/checkout';
        });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSecurityGuard);
  } else {
    initSecurityGuard();
  }
})();
